<template>
  <div
    :class="{'timer-widget': true, 'dark': dark, 'mb-3': true, 'error': error != null, ...classes }"
    style="text-align: center;"
  >
    <svg width="150" height="150" viewBox="0 0 100 100">
      <circle
        r="35"
        cx="50"
        cy="50"
        :stroke-dasharray="circumference"
        stroke="#3e98c7"
        stroke-width="25"
        fill="none"
        transform="scale(-1,1) translate(-100,0) rotate(-90, 50, 50)"
      />
    </svg>
    <div style="margin-top: 10px; font-size: 20px;">{{ formattedTime }}</div>
    <div>
      <button @click="toggle">{{ running ? 'Stop' : 'Start' }}</button>
      <button @click="reset">Reset</button>
    </div>
  </div>
</template>
<script>
const SOUNDURL = 'http://soundbible.com/mp3/analog-watch-alarm_daniel-simion.mp3'
export default {
  props: {
    name: String,
    duration: { type: Number, required: true }, // seconds
    onStart: Function,
    onStop: Function,
    onReset: Function,
    id: String,
    error: String,
    classes: Object,
    dark: Boolean
  },
  data() {
    return {
      timeLeft: this.duration,
      timer: null,
      audio: new Audio(SOUNDURL),
      running: false,
    };
  },
  computed: {
    formattedTime() {
      const m = Math.floor(this.timeLeft / 60).toString().padStart(2, '0');
      const s = (this.timeLeft % 60).toString().padStart(2, '0');
      return `${m}:${s}`;
    },
    circumference() {
      const radius = 35;
      const perimeter = 2 * Math.PI * radius;
      const section = perimeter * this.timeLeft/this.duration;
      return `${section} ${perimeter}`
    },
  },
  methods: {
    alarm() {
      this.audio.play();
    },
    start() {
      if (this.timer || this.timeLeft <= 0) return;
      this.running = true;
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          this.alarm();
          this.stop();
          debugger; // eslint-disable-line no-debugger
        }
      }, 1000);
      this.onStart?.();
    },
    stop() {
      clearInterval(this.timer);
      this.timer = null;
      this.running = false;
      this.onStop?.();
    },
    reset() {
      this.stop();
      this.audio.pause();
      this.timeLeft = this.duration;
      this.onReset?.();
    },
    toggle() {
      this.audio.pause();
      this.running ? this.stop() : this.start();
    },
  },
  beforeDestroy() {
    this.stop();
  },
};
</script>
<style>
.timer-widget button {
  border: 0px;
  background: black;
  color: white;
  border-radius: 15px;
  padding: 10px 15px;
  margin: 4px;
}
</style>
